export const BET_KEYS = ['banker', 'player', 'tie', 'bankerPair', 'playerPair'];
export const BET_LABELS = ['庄', '闲', '和', '庄对', '闲对'];
export const BET_ODDS = [0.95, 1, 8, 11, 11];
export const CHIP_VALUES = [50, 100, 500, 1000, 5000, 10000, 50000, 'all'];

export function normalizeBalance(value) {
  return Math.max(0, Math.floor(Number(value) || 0));
}

export function formatBalance(value) {
  return normalizeBalance(value).toLocaleString('en-US');
}

export function normalizeBets(values) {
  return Array.from({ length: 5 }, (_, index) => Math.max(0, Math.floor(Number(values?.[index]) || 0)));
}

export function sumBets(values) {
  return normalizeBets(values).reduce((sum, value) => sum + value, 0);
}

export function adjustBetsForLimits({ pending, placed, limits, balance, bettingOpen = true }) {
  if (!bettingOpen) throw new Error('当前桌台已停止下注');
  const bets = normalizeBets(pending);
  const local = normalizeBets(placed);
  if (!bets.some((value) => value > 0)) throw new Error('您还没有放置筹码');
  const safeLimits = {
    mainMin: Math.max(0, Number(limits?.mainMin) || 0),
    mainMax: Math.max(0, Number(limits?.mainMax) || 0),
    tieMin: Math.max(0, Number(limits?.tieMin) || 0),
    tieMax: Math.max(0, Number(limits?.tieMax) || 0),
    pairMin: Math.max(0, Number(limits?.pairMin) || 0),
    pairMax: Math.max(0, Number(limits?.pairMax) || 0)
  };
  const adjusted = bets.slice();
  const changed = new Array(5).fill(false);
  const cap = (index, value) => {
    const next = Math.max(0, Math.floor(value));
    if (next !== adjusted[index]) changed[index] = true;
    adjusted[index] = next;
  };

  if (safeLimits.mainMax > 0) {
    cap(0, Math.min(adjusted[0], safeLimits.mainMax - (local[0] - local[1])));
    cap(1, Math.min(adjusted[1], safeLimits.mainMax - (local[1] - local[0])));
  }
  if (adjusted[0] > 0 && safeLimits.mainMin > adjusted[0] + local[0]) cap(0, safeLimits.mainMin);
  if (adjusted[1] > 0 && safeLimits.mainMin > adjusted[1] + local[1]) cap(1, safeLimits.mainMin);

  if (safeLimits.tieMax > 0) cap(2, Math.min(adjusted[2], safeLimits.tieMax - local[2]));
  if (adjusted[2] > 0 && safeLimits.tieMin > adjusted[2] + local[2]) cap(2, safeLimits.tieMin);

  if (safeLimits.pairMax > 0) {
    cap(3, Math.min(adjusted[3], safeLimits.pairMax - local[3] - local[4]));
    cap(4, Math.min(adjusted[4], safeLimits.pairMax - local[3] - local[4] - adjusted[3]));
  }
  if (adjusted[3] > 0 && safeLimits.pairMin > adjusted[3] + local[3] + local[4]) cap(3, safeLimits.pairMin);
  if (adjusted[4] > 0 && safeLimits.pairMin > adjusted[4] + local[3] + local[4]) cap(4, safeLimits.pairMin);

  const total = sumBets(adjusted);
  if (total <= 0) throw new Error('本次下注超过本台限红');
  if (total > normalizeBalance(balance)) throw new Error('账户余额不足');
  return { adjusted, changed, total };
}

export function formatBetLine(index, value, label = BET_LABELS[index]) {
  const amount = Math.max(0, Math.floor(Number(value) || 0));
  return `${label} ${amount.toLocaleString('en-US')}@${BET_ODDS[index]}`;
}
